import { isFormValid, syncProfileMarker } from '../../../../library/Core/SmartFunctions';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import logger from '../../../../library/Core/logger';
import { AlumniProfileEditScreens } from '../../../../services/screen-navigation.service';
import StudentService from '../../../../services/student.service';
import { navigateToNextStep } from '../../services/profile-next-step-navigator';

export const handleNext = (
    event: React.SyntheticEvent<HTMLButtonElement>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void,
    globalState: any,
    globalDispatch: (dispatchEvent: DispatchEvent) => void,
    sessionState: any,
    sessionDispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();
    logger.log(state.data['profile']);

    const errorKeysToIgnore = getErrorsToIgnore(state);
    if (!isFormValid(state, dispatch, errorKeysToIgnore)) {
        alert('Please correct the form errors!');
        return;
    }

    const payload = {
        ...state?.data['recruiterInfo'],
        recruiterJobs: Array.isArray(state?.data?.recruiterJobs)
            ? state?.data?.recruiterJobs
            : [state?.data?.recruiterJobs].filter(Boolean),
    };

    StudentService.pageSave(
        state.routeInfo.id,
        state.routeInfo.pageName,
        payload,
    ).then(() => {
        return state.actions['REDIRECT'](`/alumni/${state.routeInfo.id}/profile/recruiter-profile`);
    });
};

const getErrorsToIgnore = (state: State) => {
    if (state.data.profile.passOutYear > new Date().getFullYear() - 2 && state.data.profile.didYouTakeGapAfter12 === true)
        return ['profile.educationOrEmploymentCurrentStatusCode'];
};